import { render, staticRenderFns } from "./HotNewsList.vue?vue&type=template&id=bde7e326&scoped=true"
import script from "./HotNewsList.vue?vue&type=script&lang=js"
export * from "./HotNewsList.vue?vue&type=script&lang=js"
import style0 from "./HotNewsList.vue?vue&type=style&index=0&id=bde7e326&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde7e326",
  null
  
)

export default component.exports